import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from 'react-redux'
import {NavLink, useLocation} from "react-router-dom";
import {createTheme, MuiThemeProvider} from "@material-ui/core/styles";
import {tableTheme} from "../../components/customTable/TableTheme";
import ActionsOptions from "../../components/customTable/ActionsOptions";
import ActionsWrapper from "../../components/customTable/ActionsWrapper";
import EditButton from "../../components/customTable/EditButton";
import DeleteButton from "../../components/customTable/DeleteButton";
import NavigateButton from "../../components/customTable/NavigateButton";
import SearchButton from "../../components/customTable/SearchButton";
import FilterButton from "../../components/customTable/FilterButton";
import {StaticTableOptions} from "../../components/customTable/StaticTableOptions";
import AddButton from "../../components/customTable/AddButton";
import {addMinistryData, deleteMinistryData, fetchMinistryData, updateMinistryData} from "../../store/ministry/ministryActions";
import MUIDataTable from "mui-datatables";
import DeleteDialog from "../../components/dialogs/DeleteDialog";
import AddDialog from "../../components/dialogs/AddDialog";
import DialogHeader from "../../components/dialogs/DialogHeader";
import TextInput from "../../components/textInput/TextInput";

function Ministries({ getMuiTheme = () => createTheme(tableTheme) }) {

    const dispatch = useDispatch()
    const language = useSelector(state => state.userInfos.language)
    const ministries = useSelector(state => state.ministries.ministries)
    const isMinistry = useSelector(state=>state.ministries.isMinistry)
    const TableOptions = useSelector(state => state.tableOptions.options)
    const [openAdd, setOpenAdd] = useState(false)
    const [openDelete, setOpenDelete] = useState(false)
    const [openEdit, setOpenEdit] = useState(false)
    const [ministryId, setMinistryId] = useState(false)

    const cancelAddRef = useRef(null)
    const cancelDeleteRef = useRef(null)

    const [ministry, setMinistry] = useState({})

    const location = useLocation()
    const  { pathname } = location
    const url = pathname.split("/")
    const regionId = url[3]
    const cityId = url[5]

    const cols = [
        {
            name: "name",
            label: language.ministry_name,
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta) => {
                    return (
                        <NavLink to={`/admin/regions/${regionId}/cities/${cityId}/ministries/${ministries[tableMeta.rowIndex].id}/directorates`}>{value}</NavLink>
                    );
                }
            }
        },
        {
            name: "",
            options: {
                ...ActionsOptions,
                customBodyRender: (value, tableMeta, rowIndex) => {
                    return (
                        <ActionsWrapper>
                            <EditButton
                                onClick={() => {
                                    setMinistryId(ministries[tableMeta.rowIndex].id)
                                    setOpenEdit(true)
                                    setOpenAdd(true)
                                    setMinistry(ministries[tableMeta.rowIndex])
                                }}
                            />
                            <DeleteButton
                                onClick={() => {
                                    setMinistryId(ministries[tableMeta.rowIndex].id)
                                    setOpenDelete(true)
                                }
                                }
                            />
                            <NavigateButton navigate={`/admin/regions/${regionId}/cities/${cityId}/ministries/${ministries[tableMeta.rowIndex].id}/directorates`} />
                        </ActionsWrapper>
                    );
                }
            }
        }];

    const components = {
        icons: {
            SearchIcon: SearchButton,
            ViewColumnIcon: FilterButton,
        }
    }

    const options = {
        ...TableOptions, ...StaticTableOptions,
        selectableRows: "multiple",
        customToolbar: () => {
            return (
                <AddButton onClick={() => {
                    setOpenAdd(true)
                    setOpenEdit(false)
                }} />
            )
        }
    }

    const saveMinistry = () => {
        dispatch(addMinistryData(cityId,ministry.name))
        setOpenAdd(false)
    }

    const deleteMinistry = () => {
        dispatch(deleteMinistryData(ministryId))
        setOpenDelete(false)
    }

    const editMinistry = () => {
        dispatch(updateMinistryData(ministryId, ministry.name))
        setOpenEdit(false)
        setOpenAdd(false)
    }

    useEffect(() => {
        dispatch(fetchMinistryData(cityId))
    }, [dispatch,isMinistry,cityId])

    return (
        <div>
            <div className="container mt-3 px-3 mx-auto max-w-screen-lg data-table">
                <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        className="w-full z-0"
                        title={language.ministries}
                        data={ministries}
                        columns={cols}
                        options={options}
                        components={components}
                    />
                </MuiThemeProvider>
            </div>
            <DeleteDialog
                openDelete={openDelete}
                cancelDeleteRef={cancelDeleteRef}
                setOpenDelete={setOpenDelete}
                deleteItem={deleteMinistry}
                title={language.delete_ministry}
                warning={language.ministry_delete_warning}
            />
            <AddDialog
                isEdit={openEdit}
                openAdd={openAdd}
                setOpenEdit={setOpenEdit}
                setOpenAdd={setOpenAdd}
                cancelAddRef={cancelAddRef}
                saveItem={saveMinistry}
                editItem={editMinistry}
            >
                <DialogHeader
                    closeModal={() => setOpenAdd(false)}
                    title={openEdit ? language.edit_ministry : language.add_ministry}
                />
                <TextInput
                    label={language.ministry_name}
                    value={openEdit ? ministry.name : null}
                    onChange={(e) => setMinistry({ ...ministry, name: e.target.value })}
                    placeholder={language.ministry_name}
                />
            </AddDialog>
        </div>
    );
}

export default Ministries;